var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-top[data-v-08e56b2e]{min-height:3.6rem;background:url(" + escape(require("../../assets/image/home-bg.png")) + ") no-repeat;background-size:100% 100%;text-align:center;color:#fff;padding:.48rem 0 .6rem}.home-top .home-top_title[data-v-08e56b2e]{font-size:.32rem;font-weight:bold;margin-bottom:.9rem}.home-top .line[data-v-08e56b2e]{height:.82rem;width:1px;background:rgba(255,255,255,.2)}", ""]);

// exports
